import React, { ReactNode, ElementType } from 'react'
import classnames from 'classnames'
import { dispatchEvent } from 'src/helpers/tagManager'

import styles from './BaseButton.module.scss'

const defaultProps = {
  role: 'button',
  trackOptions: {},
  trackEnabled: true,
}

export interface IBaseButtonProps {
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
  element?: ElementType; // render something other than a 'button' tag, such as an anchor
  dataQa?: string; // optional for testing purposes
  track?: string; // Calls dispatchEvent with this just before onClick handler fires
  role?: string;
  trackOptions?: object;
  trackEnabled?: boolean;
  onClick?: (args: any[]) => void;
}

const BaseButton = React.forwardRef(
  (
    {
      className,
      dataQa,
      onClick,
      track,
      trackEnabled,
      trackOptions,
      element: Element = 'button',
      ...restProps
    }: IBaseButtonProps,
    ref
  ) => (
    <Element
      data-qa={dataQa}
      className={classnames(styles.root, className)}
      ref={ref}
      onClick={
        track && trackEnabled
          ? (...args) => {
              dispatchEvent(track, trackOptions)
              onClick && onClick(args)
            }
          : onClick
      }
      {...restProps}
    />
  )
)

BaseButton.defaultProps = defaultProps
BaseButton.displayName = 'BaseButton'

export default BaseButton
